<style lang="less" scoped src="@/assets/less/manage-space/base.less"></style>

<template>
    <div>
        <div class="d-flex align-items-center justify-content-between">
            <CoInput type="search" icon="search" :placeholder="$t('placeholders.search')" v-model="searchInput" />

            <CoButton variant="primary" @click="createNewLocation()">{{ $t('labels.add') }}</CoButton>
        </div>
        <CoTable
            :loading="loading"
            :items="items"
            resizable-columns
            auto-items-per-page
            :clickableRows="true"
            @clickedRow="clickedRow"
            :columns="[
                {
                    key: 'Name',
                    title: 'Name',
                    style: 'width: 250px !important',
                },
                {
                    key: 'Address',
                    title: 'Address',
                    style: 'width: 250px !important',
                },
                {
                    key: 'Actions',
                    notSortable: true,
                    style: 'text-align:right; width: 50px;',
                },
            ]"
        >
            <template v-slot:Actions="{ item }">
                <div>
                    <CoDropdown :disablePropagation="true">
                        <template v-slot:button>
                            <CoRoundButton icon="three-dots" variant="icon" />
                        </template>
                        <CoDropdownItem :title="$t('labels.edit')" @click="clickedRow(null, item)" />
                        <CoConfirmation
                            :message="$t('messages.deletewarning')"
                            :confirmLabel="$t('labels.delete')"
                            :cancelLabel="$t('labels.cancel')"
                            class="ml-auto"
                            confirm-variant="danger"
                            @confirm="deleteLocation(item)"
                        >
                            <CoDropdownItem :title="$t('labels.delete')" />
                        </CoConfirmation>
                    </CoDropdown>
                </div>
            </template>
        </CoTable>

        <!-- Modals -->

        <!-- create/editModal -->
        <CoModal
            id="modal-create-location"
            ref="create-edit-modal"
            :title="currentlocation.ID ? $t('labels.locationedit') : $t('labels.locationcreate')"
            @close="onclose"
        >
            <template v-slot:body>
                <CoFormGroup :label="$t('labels.name')" class="mb-3">
                    <CoInput
                        v-model="currentlocation.Name"
                        :placeholder="$t('labels.name')"
                        required
                        role="text"
                        name="location name"
                    />
                </CoFormGroup>

                <CoFormGroup :label="$t('labels.address')">
                    <CoInput
                        v-model="currentlocation.Address"
                        :placeholder="$t('labels.address')"
                        required
                        role="text"
                        name="address"
                    />
                </CoFormGroup>
            </template>

            <template v-slot:footer>
                <div class="d-flex justify-content-between">
                    <CoButton @click="discardChanges">
                        {{ $t('labels.discard') }}
                    </CoButton>
                    <CoButton
                        :loading="saving"
                        variant="primary"
                        @click="currentlocation.ID ? updateLocation(currentlocation) : createLocation(currentlocation)"
                        :disabled="!currentlocation.Name || !currentlocation.Address"
                    >
                        {{ $t('labels.save') }}
                    </CoButton>
                </div>
            </template>
        </CoModal>
    </div>
</template>

<script>
import Vue from 'vue';
import { get } from 'lodash';
import axios from 'axios';
import EventBus from '@/eventBus';
import CoButton from '@/components/Atoms/co-button/CoButton.vue';
import CoInput from '@/components/Molecules/co-input/CoInput.vue';
import CoTable from '@/components/Molecules/co-table/CoTable.vue';
import CoRoundButton from '@/components/Atoms/co-round-button/CoRoundButton.vue';
import CoDropdown from '@/components/Molecules/co-dropdown/CoDropdown.vue';
import CoDropdownItem from '@/components/Molecules/co-dropdown-item/CoDropdownItem.vue';
import CoModal from '@/components/Organisms/co-modal/CoModal.vue';
import CoFormGroup from '@/components/Molecules/co-form-group/CoFormGroup.vue';
import CoConfirmation from '@/components/Molecules/co-confirmation/CoConfirmation.vue';

export default {
    name: 'SpaceLocations',
    components: {
        CoTable,
        CoInput,
        CoButton,
        CoRoundButton,
        CoDropdown,
        CoDropdownItem,
        CoModal,
        CoConfirmation,
        CoFormGroup,
    },

    data() {
        return {
            objects: [],
            loading: false,
            saving: false,
            searchInput: '',
            // create form data
            currentlocation: {
                ID: '',
                Name: '',
                Address: '',
            },
        };
    },
    computed: {
        items() {
            // Filter items based on search input
            if (this.searchInput) {
                return this.objects.filter(
                    (u) =>
                        get(u, 'Name', '').toLowerCase().includes(this.searchInput.toLowerCase()) ||
                        get(u, 'Address', '').toLowerCase().includes(this.searchInput.toLowerCase())
                );
            }
            return this.objects;
        },
    },
    mounted() {
        this.listLocations();
    },
    methods: {
        onclose() {
            this.currentlocation = {
                ID: '',
                Name: '',
                Address: '',
            };
        },
        discardChanges() {
            this.currentlocation = {
                ID: '',
                Name: '',
                Address: '',
            };
            this.$refs['create-edit-modal'].hide();
        },
        createNewLocation() {
            this.currentlocation = {
                ID: '',
                Name: '',
                Address: '',
            };

            this.$refs['create-edit-modal'].show();
        },
        clickedRow(index, item) {
            this.currentlocation = { ...item };
            this.$refs['create-edit-modal'].show();
        },
        listLocations() {
            axios({
                method: 'GET',
                url: '/admin/location/list',
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.loading = false;
                    this.objects = get(response, 'data.Locations', []);
                })
                .catch((error) => {
                    console.log(error);
                    const msg = {
                        Message: this.$t('errors.failedGeneric'),
                        Details: '',
                    };
                    EventBus.$emit('ERROR', msg);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        deleteLocation(obj) {
            const data = JSON.stringify(obj);
            this.loading = true;
            axios({
                method: 'DELETE',
                url: '/admin/location',
                data,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.listLocations();
                    const msg = {
                        Message: this.$t('messages.changessaved'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', msg);
                })
                .catch((error) => {
                    console.log(error);
                    const msg = {
                        Message: this.$t('errors.failedGeneric'),
                        Details: '',
                    };
                    EventBus.$emit('ERROR', msg);
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        createLocation(obj) {
            const data = JSON.stringify(obj);
            this.saving = true;

            axios({
                method: 'POST',
                url: '/admin/location',
                data,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.listLocations();
                    this.discardChanges();
                    const msg = {
                        Message: this.$t('messages.changessaved'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', msg);
                })
                .catch((error) => {
                    console.log(error);
                    const msg = {
                        Message: this.$t('errors.failedGeneric'),
                        Details: '',
                    };
                    EventBus.$emit('ERROR', msg);
                })
                .finally(() => {
                    this.saving = false;
                });
        },

        updateLocation(obj) {
            const data = JSON.stringify(obj);
            this.saving = true;

            axios({
                method: 'PUT',
                url: '/admin/location',
                data,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then((response) => {
                    this.listLocations();
                    this.discardChanges();
                    const msg = {
                        Message: this.$t('messages.changessaved'),
                        Details: '',
                    };
                    EventBus.$emit('INFO', msg);
                })
                .catch((error) => {
                    console.log(error);
                    const msg = {
                        Message: this.$t('errors.failedToSaveChanges'),
                        Details: '',
                    };
                })
                .finally(() => {
                    this.saving = false;
                });
        },
    },
};
</script>
